export default __webpack_public_path__ + "static/media/GooglePlay.0ef2ca65.svg";